import React from 'react';
import './DecorativeElements.css';

const DecorativeElements: React.FC = () => {
  return (
    <>
      <div className="deco-circle deco-circle-1"></div>
      <div className="deco-circle deco-circle-2"></div>
      <div className="deco-circle deco-circle-3"></div>
      <div className="deco-square deco-square-1"></div>
      <div className="deco-square deco-square-2"></div>
      <div className="deco-triangle deco-triangle-1"></div>
      <div className="deco-triangle deco-triangle-2"></div>
    </>
  );
};

export default DecorativeElements;



